/** ClinicOS / Quraco cloud — Gateway starts a real OIDC interaction; bare auth.quraco.com routes do not. */
export const CLINICOS_HOME_URL = 'https://cloud.quraco.com';
export const CLINICOS_SIGN_IN_URL = `${CLINICOS_HOME_URL}/auth`;
export const CLINICOS_SIGN_UP_URL = `${CLINICOS_HOME_URL}/signup`;
/** Opens Gateway auth with forgot=1 → Logto firstScreen=reset_password. */
export const CLINICOS_FORGOT_PASSWORD_URL = `${CLINICOS_HOME_URL}/auth?forgot=1`;

export type ClinicOSAuthSurface = 'sign-in' | 'register' | 'forgot' | 'other';

/** Map Logto experience paths to footer surface (one recovery entry: forgot-password). */
export const resolveClinicOSAuthSurface = (pathname: string): ClinicOSAuthSurface => {
  if (
    pathname.startsWith('/sign-in') ||
    pathname.startsWith('/identifier-sign-in') ||
    pathname.startsWith('/single-sign-on')
  ) {
    return 'sign-in';
  }
  if (pathname.startsWith('/register') || pathname.startsWith('/identifier-register')) {
    return 'register';
  }
  if (pathname.startsWith('/forgot-password') || pathname.startsWith('/reset-password')) {
    return 'forgot';
  }
  return 'other';
};
